import * as _ from 'lodash';
import { AttachableController } from '../../DOM/AttachableController';
import {
  AssistantPositionX,
  AssistantPositionY,
} from '../../../types/assistant-actions';
import {
  outerPositionElement,
  addPx,
  innerPositionElement,
} from '../../DOM/utils';
import {
  TOUR_TOOLTIP_WRAPPER_ID,
  TOUR_TOOLTIP_ARROW_WRAPPER_ID,
} from './TourTooltipWrapper';
import { TooltipState, DOMUtils } from '../../DOM/DOMUtils';

export class TourTooltipController extends AttachableController {
  static ELEMENT_CLASS: string = 'tour-tooltip';
  static ARROW_CLASS: string = 'tour-tooltip-arrow';
  static CONTENT_CLASS: string = 'tour-tooltip-content';
  arrowElement: HTMLElement;
  reactComponent: any;
  isReactComponentRendered: boolean;

  constructor(private readonly domUtils: DOMUtils) {
    super();
    this.element = document.querySelector<HTMLElement>(
      `#${TOUR_TOOLTIP_WRAPPER_ID}`,
    );
    this.arrowElement = this.getArrowElement();
  }

  setTooltipState(): TooltipState {
    return this.domUtils.setTooltipStateBuilder();
  }

  // setComponent(reactComponent: ComponentType<TourTooltipProps>) {
  //   this.domUtils.setTooltipComponent(reactComponent);
  // }

  // setArrowComponent(arrowComponent: ComponentType<TourTooltipArrowProps>) {
  //   this.domUtils.setTooltipArrowComponent(arrowComponent);
  // }

  show() {
    this.domUtils.setTooltipStateBuilder().show().apply();
  }

  hide() {
    this.domUtils.setTooltipStateBuilder().hide().apply();
  }

  reset() {
    this.domUtils.resetTooltip();
  }

  destroy(): void {
    this.detach();
    this.reset();
    //super.destroy();
  }

  async positionElement(
    element: HTMLElement,
    target: HTMLElement,
    positionX,
    positionY,
    offsetX,
    offsetY,
    minY,
    alignTo,
  ) {
    if (
      positionX === AssistantPositionX.Center &&
      positionY === AssistantPositionY.Center
    ) {
      await innerPositionElement(element, target, positionX, positionY, 0);
      return;
    }

    await outerPositionElement(
      element,
      target,
      positionX,
      positionY,
      0,
      true,
      offsetX,
      offsetY,
      minY,
      alignTo,
    );
    return this.setArrowPosition(positionX, positionY, offsetX, offsetY);
  }

  private getArrowElement(): any {
    return document.getElementById(TOUR_TOOLTIP_ARROW_WRAPPER_ID);
  }

  private async setArrowPosition(
    positionX: AssistantPositionX,
    positionY: AssistantPositionY,
    offsetX: number,
    offsetY: number,
  ) {
    //let position;
    // if (arrowPosition) {
    //   position = ArrowPosition[arrowPosition];
    // } else {
    //   position = !_.isUndefined(positionX)
    //     ? AssistantPositionX[positionX]
    //     : AssistantPositionY[positionY];
    // }
    //this.arrowElement.attr('position', position);
    await outerPositionElement(
      this.arrowElement,
      this.attachedToElement,
      positionX,
      positionY,
      0,
      false,
      offsetX,
      offsetY,
    );

    const offset = {
      left: 0,
      top: 0,
    };

    // Point it out of the tooltip with a little left/top offset
    if (positionX === AssistantPositionX.Left) {
      offset.left = this.arrowElement.clientWidth;
    } else if (positionX === AssistantPositionX.Right) {
      offset.left = -this.arrowElement.clientWidth;
    } else if (positionY === AssistantPositionY.Top) {
      offset.top = this.arrowElement.clientHeight;
    } else if (positionY === AssistantPositionY.Bottom) {
      offset.top = -this.arrowElement.clientHeight;
    }
    const style = window.getComputedStyle(this.arrowElement);
    this.arrowElement.style.left = addPx(style.left, offset.left);

    this.arrowElement.style.top = addPx(style.top, offset.top);
  }
}
